import { Flex, Text } from '@chatsdet/ui';
type AddressRowProps = {
  label: string;
  addresses: string[];
};

export function AddressRow({ label, addresses }: AddressRowProps) {
  if (!addresses || addresses.length === 0) {
    return null;
  }

  return (
    <Flex direction="column" gap="xs">
      <Text size="xs" className="text-muted-foreground uppercase tracking-wide">
        {label}
      </Text>
      <Flex direction="column" gap="xs">
        {addresses.map((value) => (
          <Text key={value} size="sm">
            {value}
          </Text>
        ))}
      </Flex>
    </Flex>
  );
}
